jQuery(document).ready(function ($) {
    const $container = $('#zgg-promotions-bubble-container');
    const $trigger = $('#zgg-promotions-bubble-trigger');
    const $content = $('#zgg-promotions-content');
    const $badge = $container.find('.zgg-promotions-dismiss-badge');
    const $headline = $('#zgg-promotions-headline');

    if (!$trigger.length || !$content.length) return;

    // Cookie Helpers
    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    };

    const getCookie = (name) => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    // Data from PHP
    const lastUpdated = parseInt($container.data('last-updated')) || 0;
    const count = parseInt($container.data('promotion-count')) || 0;
    const dismissedUntil = parseInt(getCookie('zgg_promotions_dismissed_until')) || 0;
    const seenUpdateTimestamp = parseInt(getCookie('zgg_promotions_seen_timestamp')) || 0;
    const headlineCooldown = getCookie('zgg_promotions_headline_cooldown');

    const now = Date.now();
    let isUnread = lastUpdated > seenUpdateTimestamp;
    let shouldShow = true;

    // If dismissed is set in future AND we haven't seen a newer update than the one we saw when dismissing
    if (dismissedUntil > now && lastUpdated <= seenUpdateTimestamp) {
        shouldShow = false;
    }

    if (shouldShow) {
        $container.fadeIn();

        // Unread logic for badge
        if (isUnread) {
            $container.addClass('has-unread-promotions');
            $trigger.addClass('has-unread');
        }

        // Headline Logic
        if ($headline.length && isUnread && !headlineCooldown) {
            setTimeout(() => {
                setCookie('zgg_promotions_headline_cooldown', '1', 3 / (24 * 60));
                $headline.addClass('visible');
                setTimeout(() => {
                    $headline.removeClass('visible');
                }, 6000);
            }, 1000);
        }

        // Toggle Logic
        const toggleBubble = () => {
            if ($container.hasClass('active')) {
                $container.removeClass('active');
                $content.removeClass('active');
            } else {
                $container.addClass('active');
                $content.addClass('active');
                if ($headline.length) $headline.removeClass('visible');

                // Mark as seen when opening
                if (isUnread) {
                    setCookie('zgg_promotions_seen_timestamp', lastUpdated, 365);
                    $container.removeClass('has-unread-promotions');
                    $trigger.removeClass('has-unread');
                    // Clear dismissal cookie to ensure bubble stays visible after interaction
                    setCookie('zgg_promotions_dismissed_until', '', -1);

                    setTimeout(() => {
                        isUnread = false;
                    }, 300);
                }
            }
        };

        $trigger.on('click', toggleBubble);

        const toggleBadge = () => {
            if (isUnread) {
                // Not dismissible if unread - maybe open bubble instead?
                toggleBubble();
                return false;
            }

            const oneDayInMs = 24 * 60 * 60 * 1000;
            setCookie('zgg_promotions_dismissed_until', now + oneDayInMs, 1);
            setCookie('zgg_promotions_seen_timestamp', lastUpdated, 365);
            $container.fadeOut();
            return false;
        };

        // Badge Click - Dismiss Logic
        $badge.on('click', toggleBadge);

        // Close when clicking outside
        $(document).on('click', (e) => {
            if ($container.hasClass('active') && !$container.is(e.target) && $container.has(e.target).length === 0) {
                toggleBubble();
            }
        });
    }
});
